import React from 'react';
import { ReferralProps } from './interface';
import { LoadingState } from '@mp';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'impact-embed': {
        widget?: string;
        children?: React.ReactNode;
      };
    }
  }
}

const ReferralEmbed = ({ url }: ReferralProps) => {
  return (
    <impact-embed widget={url}>
      <LoadingState />
    </impact-embed>
  );
};

export default ReferralEmbed;
